<template>
  <div class="upload-file">
    <el-upload
        class="upload-btn"
        v-if="!value"
        drag
        :action="action"
        :on-change="handleChange"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        :show-file-list="false"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div class="file-list" v-else>
      <div class="info">
        <el-image :src="require('@/assets/qrcode/icon.png')"></el-image>
        <div class="name">{{ value.substring(value.lastIndexOf('/') + 1) }}</div>
      </div>
      <i class="el-icon-close" @click="$emit('update:value','')"></i>
    </div>
  </div>
</template>

<script>
import {API_BASE_URL} from "@/config/setting";

export default {
  name: "UploadFile",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    action() {
      return API_BASE_URL + '/Upload/file'
    }
  },
  methods: {
    /**
     * 上传
     */
    handleChange(file) {
      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('source', 'api')
      formData.append('name', file.name)
      this.$request.post('/Upload/file', formData).then(res => {
        if (res.code === 0) {
          this.$emit('update:value', res.data.url)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.file-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;

  &:hover {
    border: 1px solid #1464FF;
  }

  .info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 40px;

    .el-image {
      width: 40px;
      height: 40px;
    }

    .name {
      font-size: 16px;
      color: #2D2D2D;
      font-weight: bold;
      margin-left: 2px;
    }
  }

  i {
    cursor: pointer;
    font-size: 16px;
  }
}
</style>